<template>
	<div class="item custom-upload-item">
		<div class="upload-label">
			<span class="label"
				>{{ field.dynamicFieldName }}<span class="required ml6" v-if="field.config == 1">*</span></span
			>
		</div>
		<div class="upload-area">
			<van-uploader
				v-model="internalImageUrl"
				:max-count="1"
				:max-size="5 * 1024 * 1024"
				:after-read="afterRead"
				@delete="handleDelete"
			>
				<div class="upload-placeholder">
					<i class="icon-font icontianjiatupian"></i>
				</div>
			</van-uploader>
			<div class="upload-remark" v-if="field.dynamicFieldDescribed">{{ field.dynamicFieldDescribed }}</div>
		</div>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useStore } from '@/utils/vue-api';
import { AliOssUpload } from '@/utils/ali-oss';
import { Uploader as VanUploader } from 'vant';

const props = defineProps({
	field: {
		type: Object,
		required: true
	},
	index: {
		type: Number,
		required: true
	}
});

const emit = defineEmits(['update']);

const store = useStore();

const internalImageUrl = ref([]);

// 监听 props 变化，初始化内部图片URL
watch(
	() => props.field.dynamicFieldValue,
	newVal => {
		if (!newVal) {
			internalImageUrl.value = [];
			return;
		}
		internalImageUrl.value = [
			{
				url: newVal,
				name: newVal
			}
		];
	},
	{ immediate: true }
);

// 更新父组件数据
const updateParent = () => {
	const url = internalImageUrl.value?.map(item => item.url)?.join(',') || '';
	emit('update', url);
};

// 上传图片
const afterRead = async file => {
	try {
		const res = await AliOssUpload({
			file: file.file,
			fileName: file.file.name
		});

		internalImageUrl.value = [
			{
				url: res.viewurl,
				name: res.fileName
			}
		];
		updateParent();
	} catch (error) {
		console.error('图片上传失败:', error);
		store.dispatch('showTooltip', { msg: '图片上传失败，请重试' });
	}
};

// 删除图片
const handleDelete = () => {
	internalImageUrl.value = [];
	updateParent();
};
</script>

<style lang="less" scoped>
.item {
	padding: 0.14rem 0;
	display: flex;
	align-items: center;
	justify-items: center;
	font-size: 0.15rem;
	color: #333;

	&:not(:last-child) {
		border-bottom: 0.5px solid #e8eaef;
	}

	&.custom-upload-item {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0.14rem 0;

		.upload-label {
			display: flex;
			flex-direction: column;
			width: 100%;

			.label {
				color: #333;
				font-size: 0.15rem;
				font-weight: 400;
			}

			.upload-tip {
				margin-top: 0.04rem;
				color: #999;
				font-size: 0.12rem;
			}
		}

		.upload-area {
			width: 100%;
			margin-top: 0.12rem;
			display: flex;
			align-items: center;
			gap: 0.14rem;

			/deep/ .van-uploader {
				&__preview-image {
					width: 1rem;
					height: 1rem;
				}
				&__preview-delete {
					width: 0.24rem;
					height: 0.24rem;
					background-color: rgba(0, 0, 0, 0.5);
					border-radius: 0 0 0 0.24rem;
					&-icon {
						font-size: 0.24rem;
					}
				}
				.van-uploader__preview {
					margin: 0;
				}
			}

			.upload-placeholder {
				width: 1rem;
				height: 1rem;
				background-color: #f7f7f7;
				position: relative;
				overflow: hidden;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.upload-remark {
				font-size: 0.14rem;
				color: #666;
			}
		}
	}

	.ml6 {
		margin-left: 0.06rem;
	}

	.required {
		color: #eb5149;
		font-size: 0.15rem;
		font-weight: 400;
		vertical-align: middle;
	}
}
</style>
